export const VALID_APP_VERSION = {
  Marpple: '4.2.0',
  MarppleShop: '2.1.0',
  Ciety: '1.0.0',
};

export const APP_STORE_LINK = {
  Marpple: {
    IOS: 'https://apps.apple.com/in/app/id1196659118',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.marppleapp',
  },
  MarppleShop: {
    IOS: 'https://apps.apple.com/in/app/id1571108536',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.marppleshop',
  },
  Ciety: {
    IOS: 'https://apps.apple.com/in/app/id6443814305',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.ciety.xyz.prod',
  },
};
